/**
 * Marker Model - Interfaces for marker data structures
 */

/**
 * Marker interface - Represents marker data properties
 */
export interface IMarker {
  sensorID: number;
  relativeX: number;
  relativeY: number;
  relativeDiameter: number;
  active: boolean;
  label: string;
  selected: boolean;
  circular: boolean;
  relativeWidth: number;
  relativeHeight: number;
}

/**
 * FlatMarker interface - Simplified marker with absolute coordinates
 */
export interface IFlatMarker {
  sensorId: number;
  x: number;
  y: number;
}
